export default {
  webUrl: window.location.protocol + '//' + window.location.hostname,
  // webUrl:'http://tmp.cnswb.com/',
  shareUrl: window.location.href.split('#')[0]
}



// WEBPACK FOOTER //
// ./src/common/js/config.js